"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltChunkImporter = void 0;
var list_1 = require("@devexpress/utils/lib/utils/list");
var AltChunkImporter = (function () {
    function AltChunkImporter(data) {
        this.data = data;
        this.altChunkInfos = [];
    }
    AltChunkImporter.prototype.insertAltChunks = function () {
        var _this = this;
        list_1.ListUtils.reverseForEach(this.altChunkInfos, function (chunkInfo) { return _this.insertAltChunk(chunkInfo); });
        this.altChunkInfos = [];
    };
    AltChunkImporter.prototype.insertAltChunk = function (_chunkInfo) {
    };
    return AltChunkImporter;
}());
exports.AltChunkImporter = AltChunkImporter;
